
import React from 'react';



function EditUserProofRow({ type, label, value, id, PDFView, onChange, onClick }) {
  
  return (
    <div className="row mt-2">
      
      {value && <div className="col-md-12"><button className="button2" type='button' onClick={onClick}>View selected ID Proof</button></div> }
      <div className="col-md-12"><input type={type} className="form-control" id={id} name={id}  onChange={onChange} /></div>
     


    </div>
  );
}

export default EditUserProofRow;